import ConfirmationDialog from '@rio-cloud/rio-uikit/ConfirmationDialog';
import { FormattedMessage } from 'react-intl';
import type { Asset } from '../types';
import { ActiveContractsWarning } from './ActiveContractsWarning';

export interface ArchiveAssetConfirmationDialogProps {
    show: boolean;
    asset: Asset;
    disableConfirm: boolean;
    isLatamTenant: boolean;
    updateAsset: () => void;
    abortArchivingAsset: () => void;
}

export const ArchiveAssetConfirmationDialog = (props: ArchiveAssetConfirmationDialogProps) => {
    const archiveAssetModalContent = (
        <div>
            <div className='text-size-16 margin-bottom-15'>
                <FormattedMessage
                    id={'intl-msg:asset.archive-confirmation-dialog.confirmation-question'}
                    values={{ assetName: props.asset.name }}
                />
            </div>
            <div className='alert alert-warning display-flex flex-column gap-15'>
                <div className='display-flex gap-10'>
                    <span className='text-color-warning text-size-h4 rioglyph rioglyph-error-sign' />
                    <div>
                        <strong className='text-size-16'>
                            <FormattedMessage
                                id={'intl-msg:asset.archive-confirmation-dialog.content.remove-data-sources.title'}
                            />
                        </strong>
                        <div>
                            <FormattedMessage
                                id={'intl-msg:asset.archive-confirmation-dialog.content.remove-data-sources.hint'}
                            />
                        </div>
                    </div>
                </div>

                {props.isLatamTenant ? (
                    ''
                ) : (
                    <div className='display-flex gap-10'>
                        <span className='text-color-warning text-size-h4 rioglyph rioglyph-error-sign' />
                        <div>
                            <strong className='text-size-16'>
                                <FormattedMessage
                                    id={'intl-msg:asset.delete-confirmation-dialog.content.booked-services.title'}
                                />
                            </strong>
                            <div>
                                <FormattedMessage
                                    id={'intl-msg:asset.delete-confirmation-dialog.content.booked-services.hint'}
                                />
                            </div>
                        </div>
                    </div>
                )}
            </div>
            <ActiveContractsWarning assetId={props.asset.id} deletionMode={false} />

            <div className='padding-top-20 children-last-margin-bottom-0'>
                <div className='text-bold margin-bottom-5'>
                    <FormattedMessage id={'intl-msg:asset.archive-confirmation-dialog.content.reason.question'} />
                </div>
                <p>
                    <FormattedMessage id={'intl-msg:asset.archive-confirmation-dialog.content.reason.explanation'} />
                </p>
            </div>
        </div>
    );

    return (
        <ConfirmationDialog
            show={props.show}
            bsSize={'sm'}
            content={archiveAssetModalContent}
            onClickConfirm={props.updateAsset}
            onClickCancel={props.abortArchivingAsset}
            cancelButtonText={<FormattedMessage id={'intl-msg:asset.archive-confirmation-dialog.button.cancel'} />}
            confirmButtonText={<FormattedMessage id={'intl-msg:asset.archive-confirmation-dialog.button.confirm'} />}
            disableConfirm={props.disableConfirm}
            useOverflow={true}
        />
    );
};
